<mat-list>
  <mat-list-item>
    <mat-icon [color]="data.color === 'primary' ? 'primary': 'warn'" mat-list-icon>{{data.icon}}</mat-icon>
    <div [class]="data.color" mat-line>{{data.message}}</div>
  </mat-list-item>
</mat-list>
